import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';

const FieldviewLoginRedirectView = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const country = searchParams.get('country');
    const language = searchParams.get('language');
    const nextUrl = searchParams.get('next_url');

    const handleFieldviewLoginRedirect = async () => {
        try {
            const providerUrl = `${settings.urls.users.fieldview}?country=${country}&language=${language}&next_url=${nextUrl}`;
            window.location.href = providerUrl;
        } catch (error) {
            enqueueSnackbar(_('Error al redirigir a Fieldview'), { variant: 'error' });
        }
        navigate(reverse('Home'));
    };

    useEffect(() => {
        handleFieldviewLoginRedirect();
    }, []);

    return null;
};

export default FieldviewLoginRedirectView;
